<template>
  <div>
    <h5 class="info-text">Información general</h5>

    <form novalidate id="provider_form" @submit.prevent="submit" class="md-layout md-gutter">
      <div class="md-layout-item md-size-33 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('providerType') && touched.providerType },
            { 'md-form-group': true },
            { 'md-error': errors.has('providerType') },
          ]"
        >
          <md-icon>supervised_user_circle</md-icon>
          <label>Tipo de proveedor</label>
          <md-select
            multiple
            required
            name="providerType"
            v-model="providerType"
            data-vv-name="providerType"
            v-validate="modelValidations.providerType"
          >
            <md-option
              v-for="type in mProviderTypes"
              :key="type.id"
              :value="type.id"
            >{{ type.name }}</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('providerType')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('providerType') && touched.providerType"
            >done</md-icon>
          </slide-y-down-transition>

          <md-button
            class="md-just-icon md-sm md-success md-round"
            @click.native="newProviderType()"
          >
            <md-icon>add</md-icon>
          </md-button>
        </md-field>
      </div>

      <div class="md-layout-item md-size-33 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('coreBusiness') && touched.coreBusiness },
            { 'md-form-group': true },
            { 'md-error': errors.has('coreBusiness') },
          ]"
        >
          <md-icon>domain</md-icon>
          <label>Giro empresarial</label>
          <md-select
            multiple
            required
            name="coreBusiness"
            v-model="coreBusiness"
            data-vv-name="coreBusiness"
            v-validate="modelValidations.coreBusiness"
          >
            <md-option v-for="cb in mCoreBusiness" :key="cb.id" :value="cb.id">{{ cb.name }}</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('coreBusiness')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('coreBusiness') && touched.coreBusiness"
            >done</md-icon>
          </slide-y-down-transition>
          <md-button
            class="md-just-icon md-sm md-success md-round"
            @click.native="newCoreBusiness()"
          >
            <md-icon>add</md-icon>
          </md-button>
        </md-field>
      </div>

      <div class="md-layout-item md-size-33 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('camps') && touched.camps },
            { 'md-form-group': true },
            { 'md-error': errors.has('camps') },
          ]"
        >
          <md-icon>domain</md-icon>
          <label>Campamentos</label>
          <md-select
            multiple
            required
            name="camps"
            v-model="camps"
            data-vv-name="camps"
            v-validate="modelValidations.camps"
          >
            <md-option v-for="camp in mCamps" :key="camp.id" :value="camp.id">
              {{
              camp.name
              }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('camps')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('camps') && touched.camps">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-66 md-small-size-100">
        <md-field
          :class="[
            {
              'md-valid':
                !errors.has('commercialName') && touched.commercialName,
            },
            { 'md-form-group': true },
            { 'md-error': errors.has('commercialName') },
          ]"
        >
          <md-icon>gavel</md-icon>
          <label>Nombre comercial</label>
          <md-input
            v-model="commercialName"
            data-vv-name="commercialName"
            type="text"
            name="commercialName"
            required
            v-validate="modelValidations.commercialName"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('commercialName')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('commercialName') && touched.commercialName"
            >done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-33 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('capacity') && touched.capacity },
            { 'md-form-group': true },
            { 'md-error': errors.has('capacity') },
          ]"
        >
          <md-icon>build</md-icon>
          <label>Capacidad</label>
          <md-input
            v-model="capacity"
            data-vv-name="capacity"
            type="text"
            name="capacity"
            required
            v-validate="modelValidations.capacity"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('capacity')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('capacity') && touched.capacity">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100 md-small-size-100">
        <md-switch v-model="doesBill">¿Factura?</md-switch>
      </div>

      <div v-show="doesBill" class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('rfc') && touched.rfc },
            { 'md-form-group': true },
            { 'md-error': errors.has('rfc') },
          ]"
        >
          <md-icon>fingerprint</md-icon>
          <label>RFC</label>
          <md-input
            name="rfc"
            type="text"
            v-model="rfc"
            data-vv-name="rfc"
            v-validate="modelValidations.rfc"
          ></md-input>
          <span
            class="md-helper-text"
            style="color: red !important"
          >El RFC no se podrá modificar después</span>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('rfc')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('rfc') && touched.rfc">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
      <div v-show="doesBill" class="md-layout-item md-size-50 md-small-size-100 ml-auto">
        <md-field
          :class="[
            { 'md-valid': !errors.has('bill_zone') && touched.bill_zone },
            { 'md-form-group': true },
            { 'md-error': errors.has('bill_zone') },
          ]"
        >
          <md-icon>explore</md-icon>
          <label>Zona de facturación</label>
          <md-select
            name="bill_zone"
            v-model="bill_zone"
            data-vv-name="bill_zone"
            v-validate="modelValidations.bill_zone"
          >
            <md-option v-for="zone in mStates" :key="zone.id" :value="zone.id">{{ zone.name }}</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('bill_zone')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('bill_zone') && touched.bill_zone" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
      <div class="md-layout">
        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox class="md-primary" v-model="resico" :disabled="retentionFourPercent">Resico</md-checkbox>
          </div>
        </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox class="md-primary" v-model="retentionFourPercent" :disabled="resico">4%</md-checkbox>
          </div>
        </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox class="md-primary" v-model="retentionEightPercent" :disabled="taxFree">8%</md-checkbox>
          </div>
        </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox
              class="md-primary"
              v-model="taxFree"
              :disabled="retentionEightPercent"
            >Exento de IVA</md-checkbox>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-100 mt-2 md-small-size-100">
        <contact-data @setAsentamiento="(v) => (asentamiento = v)" :contactData="contact"></contact-data>
      </div>
      <p>
        <md-button @click="addSecondAddress">Agregar dirección</md-button>
      </p>
      <div v-if="secondAddress" class="md-layout-item md-size-100 mt-2 md-small-size-100">
        <contact-address @setAsentamiento="(v) => (asentamiento2 = v)" :address="contact2.address"></contact-address>
      </div>
      <!-- Tools  -->
      <div class="md-layout">
        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox v-model="hasTools" class="md-primary">
              <md-icon>build</md-icon>¿Tiene herramienta?
            </md-checkbox>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox v-model="hasVehicle" class="md-primary">
              <md-icon>directions_car</md-icon>¿Tiene transporte?
            </md-checkbox>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-25 md-form-label"></label>
          <div class="md-layout-item">
            <md-checkbox v-model="hasCellphone">
              <md-icon>smartphone</md-icon>¿Tiene celular?
            </md-checkbox>
          </div>
        </div>
      </div>
    </form>

    <div class="md-layout">
      <div class="md-layout-item md-size-25 mx-auto">
        <md-button type="submit" form="provider_form" class="md-success">Continuar</md-button>
      </div>
    </div>

    <!-- ProviderTypeModal -->
    <modal v-if="providerTypeModal" @close="providerTypeModalHide">
      <template slot="body">
        <register-provider-type></register-provider-type>
      </template>
    </modal>

    <!-- CoreBusinessModal -->
    <modal v-if="coreBusinessModal" @close="coreBusinessModalHide">
      <template slot="body">
        <register-core-business></register-core-business>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import ContactData from "./ContactData";
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";
import RegisterProviderType from "./RegisterProviderType";
import RegisterCoreBusiness from "./RegisterCoreBusiness";
import providesValidatorMixin from "@/mixins/providesValidator";
import ContactAddress from "./Address";

const touched = {
  providerType: false,
  coreBusiness: false,
  commercialName: false,
  rfc: false,
  capacity: false,
  bill_zone: false,
  camps: false,
};

const modelValidations = {
  providerType: {
    required: true,
  },
  coreBusiness: {
    required: true,
  },
  camps: {
    required: true,
  },
  commercialName: {
    required: true,
    min: 5,
  },
  rfc: {
    min: 12,
    max: 13,
  },
  capacity: {
    numeric: true,
    min_value: 1,
  },
  bill_zone: {},
};

export default {
  name: "FirstStep",
  components: {
    SlideYDownTransition,
    ContactData,
    Modal,
    RegisterProviderType,
    RegisterCoreBusiness,
    ContactAddress,
  },
  mixins: [providesValidatorMixin],
  props: {
    provider: Object,
  },
  data() {
    return {
      providerTypeModal: false,
      coreBusinessModal: false,
      secondAddress: false,
      providerType: [],
      coreBusiness: [],
      camps: [],
      commercialName: "",
      doesBill: false,
      rfc: "",
      capacity: 0,
      bill_zone: null,
      contact: {
        address: {
          colony: null,
          state: null,
          municipality: null,
        },
      },
      contact2: {
        address: {
          colony: null,
        },
      },
      asentamiento: null,
      asentamiento2: null,
      resico: false,
      retentionFourPercent: false,
      retentionEightPercent: false,
      taxFree: false,
      hasTools: false,
      hasVehicle: false,
      hasCellphone: false,
      // catalogs
      mCamps: [],
      mProviderTypes: [],
      mCoreBusiness: [],
      mStates: [],
      mMunicipality: [],
      touched,
      modelValidations,
    };
  },
  mounted() {
    Promise.all([
      catalogService.fetch("provider_type"),
      catalogService.fetch("core_business"),
      catalogService.fetch("common/states"),
      catalogService.fetch("highway/camp"),
    ]).then(([providerTypes, coreBusiness, states, camps]) => {
      this.mProviderTypes = providerTypes;
      this.mCoreBusiness = coreBusiness;
      this.mStates = states;
      this.mCamps = camps;
    });
  },
  computed: {
    localProvider: {
      get() {
        return this.provider;
      },
      set(value) {
        this.providerType = value;
      },
    },
  },
  methods: {
    updateMunicipality(state) {
      return catalogService
        .fetch("common/states", state)
        .then((data) => (this.mMunicipality = data.Municipality));
    },
    providerTypeModalHide() {
      this.providerTypeModal = false;
      catalogService
        .fetch("provider_type")
        .then((res) => (this.mProviderTypes = res));
    },
    coreBusinessModalHide() {
      this.coreBusinessModal = false;
      catalogService
        .fetch("core_business")
        .then((res) => (this.mCoreBusiness = res));
    },
    newProviderType() {
      this.providerTypeModal = true;
    },
    newCoreBusiness() {
      this.coreBusinessModal = true;
    },
    selectedMunicipality(id) {
      return this.mMunicipality.find((mun) => mun.id === id);
    },
    addSecondAddress() {
      this.secondAddress = !this.secondAddress;
      if (!this.secondAddress) {
        this.contact2 = {
          address: {
            colony: null,
          },
        };
      }
    },
    buildData() {
      let prov = {
        name: this.contact.contact,
        provider_type: this.providerType,
        core_business: this.coreBusiness,
        camp: this.camps,
        commercial_name: this.commercialName,
        does_bill: this.doesBill || false,
        rfc: this.rfc,
        capacity: this.capacity,
        bill_zone: this.bill_zone,
        has_tools: this.hasTools,
        has_vehicle: this.hasVehicle,
        has_cellphone: this.hasCellphone,
        resico: this.resico,
        retention_four_percent: this.retentionFourPercent,
        retention_eight_percent: this.retentionEightPercent,
        tax_free: this.taxFree,
        profile: {
          address: [
            {
              asentamiento: this.asentamiento,
              state: this.contact.address.state,
              municipality: this.contact.address.municipality,
              street: this.contact.address.street,
              no_int: this.contact.address.noInt,
              no_ext: this.contact.address.noExt,
              colony: this.contact.address.colony,
              postal_code: this.contact.address.postalCode,
            },
          ],
          phone: this.contact.phone,
          phone_ext: this.contact.phoneExt,
          alternative_email: this.contact.alternativeEmail,
          cellphone: this.contact.cellphone,
        },
      };
      if (Object.keys(this.contact2.address).length !== 1) {
        let payload = {
          asentamiento2: this.asentamiento2,
          state: this.contact2.address.state,
          municipality: this.contact2.address.municipality,
          street: this.contact2.address.street,
          no_int: this.contact2.address.noInt,
          no_ext: this.contact2.address.noExt,
          colony: this.contact2.address.colony,
          postal_code: this.contact2.address.postalCode,
        };

        prov.profile.address.push(payload);
      }
      return prov;
    },
    submit() {
      this.isValid().then((res) => {
        if (res) {
          if (!this.asentamiento) {
            this.$alertMessage({
              title: "No se pudo guardar el asentamiento seleccionado",
            });
            return;
          }
          this.updateMunicipality(this.contact.address.state);
          let prov = this.buildData();
          if (!prov.rfc) {
            this.$alertMessage({
              title: "Faltan campos por llenar",
            });
            return;
          }
          this.$http
            .post("catalogs/providers/", prov)
            .then((res) => {
              this.$emit("success", res.data);
            })
            .catch(this.$fireErrorResponse);
        }
      });
    },
    isValid() {
      return this.$validator.validateAll().then((res) => res);
    },
  },
  watch: {
    coreBusiness() {
      this.touched.coreBusiness = true;
    },
    providerType() {
      this.touched.providerType = true;
    },
    firstName() {
      this.touched.firstName = true;
    },
    lastName() {
      this.touched.lastName = true;
    },
    mothersLastName() {
      this.touched.mothersLastName = true;
    },
    bill_zone() {
      this.touched.bill_zone = true;
    },
    camps() {
      this.touched.camps = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Providers/wizard/FirstStep.vue